import { definitions } from 'api/generated/search'
import { SearchFields } from 'api/search/fetchSearchSettingsListApi'
import { Constitution } from 'common-constants/api6.types'
import { DefaultSearchForm } from 'components/page/MainSearchSettings/constants'
import { MainSearchState } from 'reducers/search/MainSearchState'

export const formOptionsUpdate = (
  result: definitions['SearchFormResultWithRequest']
): Partial<MainSearchState> => {
  return {
    loaded: true,
    searchSettingsLoading: false,
    searchSettingsLoaded: true,
    /**
     * Ошибка бекенда: https://youtrack.mamba.ru/issue/M-3808
     */
    settingsFields: result.formSettings
      .fields as unknown as unknown as SearchFields,
    lexemes: result.formSettings.lexemes as unknown as Record<string, string>,
    form: {
      ...result.formOptions,
      constitution: Object.values(
        result.formOptions.constitution
      ) as Constitution[],
      currentLocation: {
        ...result.selectedLocation,
      },
    } as unknown as DefaultSearchForm,
    formSettings: result.formSettings,
    interests: result.interests,
    showInterests: result.showInterests,
    defaultStateForm: {
      ...result.formOptions,
      currentLocation: {
        ...result.selectedLocation,
      },
      constitution: Object.values(
        result.formOptions.constitution
      ) as Constitution[],
    } as unknown as DefaultSearchForm,
  }
}
